import debug from 'bows/dist/bows.min.js';
import $ from "jquery";

const log = debug("scrollTriggers");


export function init() {
    $(window).on( "scroll", function() {
        var s = $(window).scrollTop();
    
        if (s > 456) {
            $('body').addClass('show-jump');
        } else {
            $('body').removeClass('show-jump');
        }
    });
}

export default {
	init
};